import gsap from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const blogList = document.querySelector(".blog-page__list");
  let blogCards = blogList?.querySelectorAll(".blog-card");
  const loadMore = document.querySelector(".blog-page__button");
  const showBadge = document.querySelector(".blog-page__badge-button");
  const badgeList = document.querySelector(".blog-page__badge-list");
  const blogPreview = document.querySelector(".blog-page__preview");
  const blogContainer = document.querySelector(".blog-page__container");

  if (blogList && blogCards && loadMore) {
    let length = 12;

    const showCards = () => {
      for (let i = 0; i < length; i++) {
        if (!blogCards[i]) return;
        blogCards[i].classList.add("blog-card--view");
      }
    };
    showCards();
    window.createNewCard = () => {
      blogCards = blogList?.querySelectorAll(".blog-card");
      length = 12;
      if (length >= blogCards.length) loadMore.classList.add("blog-page__button--hidden");
      showCards();
    };
    const showNewCard = () => {
      length = length + 6;
      gsap.to(blogList, { height: blogList.clientHeight, delay: 0, duration: 0 });
      showCards();
      gsap.to(blogList, { height: "auto", delay: 0, duration: 0.3 });
      if (length >= blogCards.length) loadMore.classList.add("blog-page__button--hidden");
    };

    loadMore.addEventListener("click", () => showNewCard);

    let timeout;

    window.addEventListener("scroll", () => {
      const scrollHeight = window.scrollY + window.innerHeight;
      const blogHeight = blogContainer.offsetTop + blogContainer.clientHeight;
      if (scrollHeight >= blogHeight) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          showNewCard();
        }, 300);
      }
    });
  }

  if (blogPreview) {
    const blogCard = blogPreview.querySelector(".blog-card");

    const checkSize = () => {
      if (window.innerWidth > 1024) {
        blogCard.classList.add("blog-card--long");
      } else {
        blogCard.classList.remove("blog-card--long");
      }
    };

    window.addEventListener("resize", checkSize);
    checkSize();
  }

  if (showBadge && badgeList) {
    showBadge.addEventListener("click", () => {
      const showTegsText = showBadge.querySelector("#show-tags");
      const closeTegsText = showBadge.querySelector("#close-tags");

      if (window.innerWidth < 1024) {
        if (showBadge.classList.contains("blog-page__badge-button--view")) {
          showBadge.classList.remove("blog-page__badge-button--view");
          showTegsText.style.display = "block";
          closeTegsText.style.display = "none";
          gsap.to(badgeList, { height: 0, duration: 0.3, delay: 0 });
        } else {
          showBadge.classList.add("blog-page__badge-button--view");
          showTegsText.style.display = "none";
          closeTegsText.style.display = "block";
          gsap.to(badgeList, { height: "auto", duration: 0.3, delay: 0 });
        }
      }
    });

    window.addEventListener("resize", () => {
      if (window.innerWidth >= 1024) {
        // showBadge.classList.remove("blog-page__badge-button--view");
        // showBadge.innerHTML = 'SHOW TEGS'
        // gsap.to(badgeList, { height: 0, duration: 0, delay: 0 });
      }
    });
  }
});
